export default __webpack_public_path__ + "static/port2-e570af0d9765ccecc36bce3cd899634f.jpg";